export default "__VITE_ASSET__qs$uoJUp__"